
import React from 'react';
import { Badge } from '@/components/ui/badge';

const PricingHeader: React.FC = () => {
  return (
    <div className="mb-8 text-center">
      <Badge variant="outline" className="mb-2 px-3 py-1 bg-yellow-300 border-yellow-500 text-darkgray font-opensans">Nyhet</Badge>
      <h3 className="text-2xl font-montserrat font-bold">Prova utan kostnad i 14 dagar</h3>
      <p className="text-darkgray/70 mt-1 font-opensans">Testa alla analysverktyg utan begränsningar innan du bestämmer dig</p>
    </div>
  );
};

export default PricingHeader;
